import { render, staticRenderFns } from "./BindAccount.vue?vue&type=template&id=386f6301&"
import script from "./BindAccount.vue?vue&type=script&lang=js&"
export * from "./BindAccount.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports